var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:("a-avatar-primary a-avatar-side a-avatar-" + _vm.avatarClass)},[(_vm.userImage.length)?_c('img',{key:"avatarImg",attrs:{"src":_vm.userImage}}):_c('img',{key:"defaultImg",attrs:{"src":require("@/assets/img/avatar.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }